<template lang="pug">
	header.sfc-header-no-nav
		b-container(fluid)
			b-row
				b-col()
					a.logo(href="/") SavingForCollege Logo
				b-col
					.phone
						a(tel="5852865426") (585) 286 - 5426

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	header.sfc-header-no-nav
		>>> .container-fluid
			max-width: 90%
		border-bottom 1px solid sfc-pale-gray
		background #fff
		width 100%
		>>> .logo
			background url(https://web-resources.savingforcollege.com/images/logo-sfc.png) no-repeat
			background-size contain
			text-indent -999999px
			display block
			height 50px
			margin 10px 0
			max-width: 200px
		>>> .phone
			color sfc-pale-gray
			margin 25px 0
			text-align: right
			a
			a:not([href])
				transition-all()
				text-decoration: none
				cursor: pointer
				color: text-gray
				&:hover
					text-decoration underline
					color: text-gray
</style>

<script>
export default {

}
</script>
